import styled from 'styled-components';

import { Box } from 'components/Box';
import { colors, mediaRetina, transition } from 'theme';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/jsx-props-no-spreading
export const Tag = styled(({ small, large, ...props }) => <Box {...props} />)`
  height: 34px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  background: transparent;
  background: white;
  border-radius: 5px;
  box-shadow: 0 0 0 1px ${colors.selectionGrey} inset;
  color: ${colors.lightContentGrey};
  font-size: ${(props) => (props.large ? 14 : 12)}px;
  line-height: normal;
  text-decoration: none;
  transition: all ${transition};
  ${(props) =>
    !props.small
      ? `
    letter-spacing: 0.6px;
    text-transform: uppercase;
  `
      : `
  `}

  &:hover,
  &:focus {
    background: ${colors.brandGreen};
    box-shadow: 0 0 0 1px ${colors.brandGreen} inset;
    color: white;
  }

  &[disabled] {
    cursor: default;
  }

  ${mediaRetina} {
    box-shadow: inset 0 0 0 1.5px ${colors.selectionGrey};
    &:not([disabled]):hover {
      box-shadow: inset 0 0 0 1.5px ${colors.brandGreen};
    }
  }
`;
